import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";

const MONO = "'Space Grotesk', 'Noto Sans Lao', ui-monospace, monospace";
const SYM = { THB: "฿", LAK: "₭", USD: "$" };
const money = (n, c = "THB") => `${SYM[c] || ""}${(Number(n) || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
const labelSx = { fontSize: "10.5px", letterSpacing: ".14em", color: "#a8a3b4", fontWeight: 700 };

function Kpi({ label, value, color, sub, highlight }) {
  return (
    <Box sx={{
      background: highlight ? "linear-gradient(155deg,#fff 0%,#f5efff 100%)" : "#fff",
      border: `1px solid ${highlight ? "#ece4fb" : "#ece9f1"}`,
      borderRadius: "18px",
      p: "18px 20px",
      boxShadow: highlight
        ? "0 1px 2px rgba(20,18,30,.04),0 14px 28px -20px rgba(86,40,160,.22)"
        : "0 1px 2px rgba(20,18,30,.04),0 14px 28px -20px rgba(20,18,30,.12)",
    }}>
      <Box sx={labelSx}>{label.toUpperCase()}</Box>
      <Box sx={{ fontFamily: MONO, fontSize: 22, fontWeight: 700, color, mt: "8px" }}>{value}</Box>
      {sub && <Box sx={{ fontFamily: MONO, fontSize: 12, fontWeight: 600, color: "#a8a3b4", mt: "3px" }}>{sub}</Box>}
    </Box>
  );
}

// Total (THB) + per-currency tiles, summed over the given station balances.
// `balances` = [{ THB, LAK, USD }]; pass one station for the drill-down, or all
// of the user's stations for the overview.
export default function BranchCashKpis({ balances = [], rate }) {
  const { t } = useTranslation();
  const sum = balances.reduce(
    (a, b) => ({ THB: a.THB + (Number(b.THB) || 0), LAK: a.LAK + (Number(b.LAK) || 0), USD: a.USD + (Number(b.USD) || 0) }),
    { THB: 0, LAK: 0, USD: 0 }
  );
  const lakTHB = rate && rate.LAK ? sum.LAK / Number(rate.LAK) : 0;
  const usdTHB = rate && rate.USD ? sum.USD * Number(rate.USD) : 0;
  const totalTHB = sum.THB + lakTHB + usdTHB;

  return (
    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr 1fr", md: "repeat(4,1fr)" }, gap: "16px" }}>
      <Kpi highlight label={t("financial.totalThb")} value={money(totalTHB, "THB")} color="#6d28d9" sub="THB + LAK + USD" />
      <Kpi label="THB" value={money(sum.THB, "THB")} color="#161420" />
      <Kpi label="LAK" value={money(sum.LAK, "LAK")} color="#161420" sub={`≈ ${money(lakTHB, "THB")}`} />
      <Kpi label="USD" value={money(sum.USD, "USD")} color="#161420" sub={`≈ ${money(usdTHB, "THB")}`} />
    </Box>
  );
}
